import { graphql } from '../../gql'

export const MeQuery = graphql(/* GraphQL */`
    query Me {
        me {
            id
            email
            username
            fullName
            createdAt
            updatedAt
            business {
                id
                name
                wasteReductionPerCycle
                co2ReductionPerKiloWaste
                scanLocations {
                    id
                    name
                    formattedAddress
                }
            }
        }
    }
`)
